/*eslint-disable*/
import CameraIcon from "../../assets/icons/CameraIcon";
import UploadIcon from "../../assets/icons/UploadIcon";
import { TOAST_TYPES } from "../../app/constants";
import { useConfig } from "../../app/context/Config/configContext";
import { useNotification } from "../../app/context/Notification";
// import LoaderDark from "../common/LoaderDark/LoaderDark";
import ImageUploadLoader from "./Loader";
import gluedin from "gluedin-shorts-js";
import React, { useRef, useState } from "react";
import { useDropzone } from "react-dropzone";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

function CreatePost() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const inputRef = useRef(null);
  const [isUploadingVideo, setIsUploadingVideo] = useState(false);
  const userData = JSON.parse(localStorage.getItem("userData") || "{}");
  const { showNotification } = useNotification();
  const { appConfig } = useConfig();

  const videoMimeTypes = ["video/mp4", "video/mpeg"];
  const imageMimeTypes = ["image/jpeg", "image/jpg", "image/png"];

  const getMediaLabel = (mediaType: "video" | "image") =>
    mediaType === "image" ? "Image" : "Video";

  const getMediaType = (fileUploaded: any) => {
    if (videoMimeTypes.includes(fileUploaded.type)) return "video";
    if (imageMimeTypes.includes(fileUploaded.type)) return "image";
    return null;
  };

  const handleFileUploadChange = (files: any) => {
    const fileUploaded = files[0];
    if (!fileUploaded) {
      return;
    }
    if (
      (userData?.creator && appConfig?.inviteOnlyCreation) ||
      (!appConfig?.inviteOnlyCreation && appConfig?.ugcEnabled)
    ) {
      const mediaType = getMediaType(fileUploaded);
      if (!mediaType) {
        showNotification({
          title: "File not uploaded",
          subTitle: "File format should be .mp4, .jpeg, .jpg, or .png",
          autoClose: false,
          type: TOAST_TYPES.ERROR,
        });
      } else {
        if (mediaType === "image") {
          readFile(fileUploaded, "image");
          files = null;
          return;
        }
        const mediaLabel = getMediaLabel(mediaType);
        let fileSize = fileUploaded.size / 1024 / 1024;
        if (fileSize > 5000000) {
          setIsUploadingVideo(false);
          showNotification({
            title: "File not uploaded",
            subTitle: "File size is more than 50 MB",
            autoClose: false,
            type: TOAST_TYPES.ERROR,
          });
          inputRef.current = null;
          return;
        }
        const videoElement = document.createElement("video");
        videoElement.preload = "metadata";
        videoElement.onloadedmetadata = () => {
          window.URL.revokeObjectURL(videoElement.src);
          const duration = videoElement.duration;
          if (duration > 600000 || duration < 6) {
            showNotification({
              title: "File not uploaded",
              subTitle: `${mediaLabel} duration should be greater than 6 seconds and less than 60 seconds`,
              autoClose: false,
              type: TOAST_TYPES.ERROR,
            });
            inputRef.current = null;
            return;
          } else {
            readFile(fileUploaded, "video");
          }
        };

        videoElement.onerror = () => {
          setIsUploadingVideo(false);
          showNotification({
            title: "File not uploaded",
            subTitle: `Unable to load ${mediaLabel.toLowerCase()} file`,
            autoClose: false,
            type: TOAST_TYPES.ERROR,
          });
          inputRef.current = null;
        };

        videoElement.src = URL.createObjectURL(fileUploaded);
      }
      files = null;
    } else {
      showNotification({
        title: "File not uploaded",
        subTitle:
          "This functionality is restricted to authorized users only. Please contact the support team",
        autoClose: false,
        type: TOAST_TYPES.ERROR,
      });
      return;
    }
  };

  const handleMediaUpload = async (
    signedUrl: any,
    inputFile: any,
    mediaUrl: any,
    mediaType: "video" | "image"
  ) => {
    try {
      const mediaUrlBlob = URL.createObjectURL(inputFile);
      const mediaKey = mediaType === "image" ? "imageUrls" : "videoUrls";
      sessionStorage.setItem(mediaKey, JSON.stringify([mediaUrl]));
      sessionStorage.setItem("blobUrls", JSON.stringify([mediaUrlBlob]));
      sessionStorage.setItem("signedUrl", signedUrl);
      const query = mediaType === "image" ? "?contentType=image" : "";
      navigate(`/create-post-page-02${query}`, { state: { inputFile } });
    } catch (error) {
      console.error("Media upload failed:", error);
    }
  };

  const readFile = (inputFile: any, mediaType: "video" | "image") => {
    console.log("inputFile", inputFile);
    if (inputFile) {
      setIsUploadingVideo(true);
      const reader = new FileReader();
      reader.onload = async function () {
        let {
          status,
          data: {
            result: { uploadUrl: signedUrl, url: mediaUrl },
          },
        } = await getSignedUrl(mediaType);
        if (status === 200) {
          handleMediaUpload(signedUrl, inputFile, mediaUrl, mediaType);
          //   var file = inputFile;
          //   var requestOptions: any = {
          //     method: "PUT",
          //     body: file,
          //     redirect: "follow",
          //   };
          //   fetch(signedUrl, requestOptions)
          //     .then((response) => {
          //       setIsUploadingVideo(false);
          //       const file1 = inputFile;
          //       const videoUrlBlob = URL.createObjectURL(file1);
          //       sessionStorage.setItem("videoUrls", JSON.stringify([videoUrl]));
          //       sessionStorage.setItem(
          //         "blobUrls",
          //         JSON.stringify([videoUrlBlob])
          //       );
          //       navigate("/create-post-page-02");
          //     })
          //     .then(() => {
          //       setIsUploadingVideo(false);
          //     })
          //     .catch(() => {
          //       setIsUploadingVideo(false);
          //     });
        } else {
          if (status === 401) {
            localStorage.clear();
            sessionStorage.clear();
            navigate("/sign-in");
          }
        }
      };

      reader.readAsDataURL(inputFile);
    }
  };

  const getSignedUrl = async (mediaType: "video" | "image" = "video") => {
    const feedModuleObj = new gluedin.GluedInFeedModule();
    const feedModuleResponse = await feedModuleObj.getSignedUrl({
      type: mediaType,
    });
    return feedModuleResponse;
  };

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop: handleFileUploadChange,
    accept: {
      "video/mp4": [".mp4"],
      "video/mpeg": [".mpeg"],
      "image/jpeg": [".jpeg", ".jpg"],
      "image/png": [".png"],
    },
  });

  const handleCreator = () => {
    navigate("/creator");
  };

  return (
    <>
      <div className="main_upload mt-20">
        <div
          data-isDragActive={isDragActive}
          className="main_upload-container data-[isDragActive=true]:border-[#03f] p-4"
          {...getRootProps()}
        >
          {isUploadingVideo && <ImageUploadLoader />}
          <div className="main_dropzone flex flex-col items-center justify-center">
            <div className="main_dropzone-actions">
              <input {...getInputProps()} />
              <button
                className="position"
                onClick={(event) => {
                  event.stopPropagation();
                  handleCreator();
                }}
              >
                <CameraIcon />
                Camera
              </button>
              <button disabled={isUploadingVideo} className="">
                <UploadIcon />
                <span>
                  {t("btn-select-from-computer")}
                  {/* {isUploadingVideo ? <LoaderDark /> : null}{" "} */}
                </span>
              </button>
            </div>

            <div className="main_divider">Or</div>

            <div className="c-text text-g">{t("text-drag-drop")}...!</div>
            <div className="text-sm">
              {t("text-support-file-type")}
              {/* {t("text-file-size")} */}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default CreatePost;
